define(['marionette'], function (Marionette) {
  return Marionette.ItemView.extend({
    template: false,
    initialize: function () {
      this.bindUIElements()
    }
  })
})
